import { Head, Link, useForm } from '@inertiajs/react'
import { AuthLayout } from '@/components/layout/AuthLayout'
import { Input } from '@/components/ui/Input'
import { Button } from '@/components/ui/Button'

export default function Register() {
  const form = useForm({ invitation_code: '', email: '', password: '', password_confirmation: '' })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    form.transform((data) => ({
      invitation_code: data.invitation_code,
      user: { email: data.email, password: data.password, password_confirmation: data.password_confirmation },
    }))
    form.post('/users')
  }

  return (
    <AuthLayout>
      <Head>
        <title>Create Account</title>
        <meta name="description" content="Create a Mimir Languages account. Learn languages through reading — at your own pace." />
        <link rel="canonical" href="https://mimirlang.eu/users/sign_up" />
      </Head>
      <div className="w-full max-w-sm">

        <div className="text-center mb-8">
          <p className="font-mono text-xs uppercase tracking-widest text-accent mb-4">
            Get started
          </p>
          <h1 className="font-serif text-3xl font-medium text-heading mb-2">
            Begin your journey
          </h1>
          <p className="text-sm text-muted font-light">
            No streaks, no pressure — just the language, and you.
          </p>
        </div>

        <form onSubmit={handleSubmit} noValidate className="flex flex-col gap-5">
          <Input
            id="invitation_code"
            label="Invitation code"
            type="text"
            autoComplete="off"
            placeholder="12345678"
            maxLength={8}
            value={form.data.invitation_code}
            onChange={e => form.setData('invitation_code', e.target.value)}
            error={form.errors.invitation_code}
          />

          <Input
            id="email"
            label="Email"
            type="email"
            autoComplete="email"
            placeholder="you@example.com"
            value={form.data.email}
            onChange={e => form.setData('email', e.target.value)}
            error={form.errors.email}
          />

          <Input
            id="password"
            label="Password"
            type="password"
            autoComplete="new-password"
            placeholder="••••••••"
            value={form.data.password}
            onChange={e => form.setData('password', e.target.value)}
            error={form.errors.password}
          />

          <Input
            id="password_confirmation"
            label="Confirm password"
            type="password"
            autoComplete="new-password"
            placeholder="••••••••"
            value={form.data.password_confirmation}
            onChange={e => form.setData('password_confirmation', e.target.value)}
            error={form.errors.password_confirmation}
          />

          <Button type="submit" variant="filled" disabled={form.processing} className="w-full mt-2">
            {form.processing ? 'Creating account…' : 'Create account'}
          </Button>
        </form>

        <p className="mt-8 text-center text-xs text-muted font-light">
          Already have an account?{' '}
          <Link
            href="/users/sign_in"
            className="text-body hover:text-heading transition-colors duration-200 underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded"
          >
            Sign in
          </Link>
        </p>

      </div>
    </AuthLayout>
  )
}
